import { useState, useEffect, useContext } from 'react';
import api from './api/axiosInstance';
import { UserContext } from './UserContext';
import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Sidebar from './Sidebar.js';
import { Table, Form, Row, Col, Card, Badge, Image } from 'react-bootstrap';
import defaultLogo from './assets/img/ic-img.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CompanyFilter from './CompanyFilter';
import Pagination from 'react-bootstrap/Pagination';
import CompanyImport from './CompanyImport';
import Breadcrumb from './Breadcrumb';
import { isAdminType} from './utils/roleUtils';
import { useMediaQuery } from 'react-responsive';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import icApproved from './assets/img/ic-check-circle.svg';
import icRejected from './assets/img/ic-close-circle.svg';
import icRLifecycleReview from './assets/img/ic-lyfecycle-review.svg';
import icUnderReview from './assets/img/ic-under-review.svg';
import icDelete from './assets/img/ic-delete.svg';
import icEdit from './assets/img/ic-edit.svg';
import icRepeat from './assets/img/ic-repeat.svg';
import icReview from './assets/img/ic-review.svg';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import icValidationError from './assets/img/ic-danger.svg';
import icSucess from './assets/img/ic-celebration-circle.svg';
import icNoCompanies from './assets/img/ic-empty-box.svg';
import 'bootstrap-icons/font/bootstrap-icons.css';

const CompanyList = () => {
    const navigate = useNavigate();
    const [companies, setCompanies] = useState([]);
    const [filteredCompanies, setFilteredCompanies] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const { user } = useContext(UserContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [sortOrderName, setSortOrderName] = useState('asc'); // Sorting order for company name
    const [sortOrderCountry, setSortOrderCountry] = useState('asc'); // Sorting order for country
    const [sortOrderCity, setSortOrderCity] = useState('asc'); // Sorting order for city
    const [sortOrderJobs, setSortOrderJobs] = useState('asc'); // Sorting order for jobs
    const [sortOrderUsers, setSortOrderUsers] = useState('asc'); // Sorting order for users
    const [sortOrderOnboarding, setSortOrderOnboarding] = useState('asc'); // Sorting order for onboarding
    const [sortOrderSubscription, setSortOrderSubscription] = useState('asc'); // Sorting order for subscription
    const [sortOrderStatus, setSortOrderStatus] = useState('asc'); // Sorting order for status
    const [sortOrderAccountApprovalStatus, setSortOrderAccountApprovalStatus] = useState('asc'); // Sorting order for Account Approval Status
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [showInviteModal, setShowInviteModal] = useState(false);
    const [fetchedCompanies, setFetchedCompanies] = useState([]);
    const [inviteErrors, setInviteErrors] = useState({});

    const [tickets, setTickets] = useState([]);
    useEffect(() => {
        const fetchTickets = async () => {
            try {
                // ✅ goes through interceptor; token auto-attached
                const res = await api.get('/api/tickets'); // ✅
                setTickets(res.data);
            } catch (error) {
                console.error('Error fetching tickets:', error);
            }   
        };
        fetchTickets();
    }, []);

    const [inviteData, setInviteData] = useState({
        companyName: '',
        vat: '',
        type: 'firm', // Default to 'firm'
        email: '',
        firstName: '',
        lastName: '',
        message: 'Connect with potential employees, explore lists of talents, post jobs, see industry statistics and more'
    });
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [showImportModal, setShowImportModal] = useState(false);
    
    const [companiesPerPage, setCompaniesPerPage] = useState(10);
    const indexOfLastCompany = currentPage * companiesPerPage;
    const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
    const currentCompanies = filteredCompanies.slice(indexOfFirstCompany, indexOfLastCompany);
    const isMobile = useMediaQuery({ maxWidth: 767 });



    useEffect(() => {
        if (user && isAdminType(user.role)) {
            fetchCompanies();
        }
    }, [user]);

    const fetchCompanies = async () => {
        try {

            const res = await api.get(`/api/companies`);
            setFetchedCompanies(res.data); // ✅ store in fetchedCompanies
            setCompanies(res.data); // ✅ also update displayed companies
            setFilteredCompanies(res.data);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    useEffect(() => {
        const fetchUserCounts = async () => {
            try {
                const updatedCompanies = await Promise.all(fetchedCompanies.map(async (company) => {
                if (company.usersCount !== undefined) return company;

                // ✅ use api, no manual headers needed
                const res = await api.get(`/api/users/count/by-company/${company._id}`); // ✅
                return {
                    ...company,
                    usersCount: res.data.count,
                };
            }));

            setCompanies(updatedCompanies);
            setFilteredCompanies(updatedCompanies);
            } catch (err) {
                console.error('Failed to fetch user counts:', err);
            }
        };

        if (companies.length) {
            fetchUserCounts();
        }
    }, [fetchedCompanies]);

    // Handle search filter
    useEffect(() => {
        const lowercasedQuery = searchQuery.toLowerCase();
        const filteredResults = companies.filter((company) => 
            company.title.toLowerCase().includes(lowercasedQuery) &&
            (selectedCountry === '' || company.country === selectedCountry) &&
            (selectedCity === '' || company.cityRegion === selectedCity)
        );
        
        setFilteredCompanies(filteredResults);
        setCurrentPage(1); // ✅ Reset to first page when filtering
    }, [searchQuery, selectedCountry, selectedCity, companies]);
    

    const handleDeleteCompany = (id) => {
        setSelectedCompanyId(id);
        setShowDeleteModal(true);
    };

    const confirmDeleteCompany = async () => {
        try {
            // ✅ interceptor handles token + 401
            await api.delete(`/api/companies/${selectedCompanyId}`); // ✅
            setCompanies(companies.filter(company => company._id !== selectedCompanyId));
            setShowDeleteModal(false);
        } catch (error) {
            console.error('Error deleting company:', error);
        }
    };

    const toggleActivityStatus = async (companyId, currentStatus) => {
        try {
            const updatedStatus = !currentStatus;
            // ✅ use api
            await api.patch(
                `/api/companies/${companyId}/activity-status`,
                { activityStatus: updatedStatus }
            ); // ✅
            setCompanies((prevCompanies) =>
                prevCompanies.map((company) =>
                    company._id === companyId
                        ? { ...company, activityStatus: updatedStatus }
                        : company
                )
            );
        } catch (error) {
            console.error('Error toggling activity status:', error);
        }
    };

    // Sorting function for Company Name
    const sortCompaniesByName = () => {
        const newSortOrder = sortOrderName === 'asc' ? 'desc' : 'asc';
        
        const sortedCompanies = [...filteredCompanies].sort((a, b) => {
            const nameA = a.title ? a.title.toLowerCase() : '';
            const nameB = b.title ? b.title.toLowerCase() : '';
            return newSortOrder === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });
    
        setFilteredCompanies(sortedCompanies);
        setSortOrderName(newSortOrder);
    };

    // Sorting function for Country
    const sortCompaniesByCountry = () => {
        const newSortOrder = sortOrderCountry === 'asc' ? 'desc' : 'asc';
        
        const sortedCompanies = [...companies].sort((a, b) => {
            const countryA = a.country ? a.country.toLowerCase() : '';
            const countryB = b.country ? b.country.toLowerCase() : '';
            return newSortOrder === 'asc' ? countryA.localeCompare(countryB) : countryB.localeCompare(countryA);
        });

        setCompanies(sortedCompanies);
        setSortOrderCountry(newSortOrder); // Update country sorting state
    };

    // Sorting function for City
    const sortCompaniesByCity = () => {
        const newSortOrder = sortOrderCity === 'asc' ? 'desc' : 'asc';
        
        const sortedCompanies = [...companies].sort((a, b) => {
            const cityA = a.cityRegion ? a.cityRegion.toLowerCase() : '';
            const cityB = b.cityRegion ? b.cityRegion.toLowerCase() : '';
            return newSortOrder === 'asc' ? cityA.localeCompare(cityB) : cityB.localeCompare(cityA);
        });

        setCompanies(sortedCompanies);
        setSortOrderCity(newSortOrder); // Update city sorting state
    };

    // Sorting function Account Access (subscription)
    const sortCompaniesBySubscription = () => {
        const newSortOrder = sortOrderSubscription === 'asc' ? 'desc' : 'asc';
        
        const sortedCompanies = [...companies].sort((a, b) => {
            const subscriptionA = a.accessLevel ? a.accessLevel.toLowerCase() : '';
            const subscriptionB = b.accessLevel ? b.accessLevel.toLowerCase() : '';
            return newSortOrder === 'asc' ? subscriptionA.localeCompare(subscriptionB) : subscriptionB.localeCompare(subscriptionA);
        });

        setCompanies(sortedCompanies);
        setSortOrderSubscription(newSortOrder); // Update subscription sorting state
    };

    // Sorting function for Job Numbers (numerical sorting)
    const sortCompaniesByJob = () => {
        const newSortOrder = sortOrderJobs === 'asc' ? 'desc' : 'asc';
    
        setFilteredCompanies((prevCompanies) => 
            [...prevCompanies].sort((a, b) => {
                const jobsA = a.openJobsTotal || 0;
                const jobsB = b.openJobsTotal || 0;
                return newSortOrder === 'asc' ? jobsA - jobsB : jobsB - jobsA;
            })
        );
    
        setSortOrderJobs(newSortOrder);
    };

    // Sorting function for User Numbers (numerical sorting)
    const sortCompaniesByUsers = () => {
        const newSortOrder = sortOrderUsers === 'asc' ? 'desc' : 'asc';
    
        setFilteredCompanies((prevCompanies) => 
            [...prevCompanies].sort((a, b) => {
                const usersA = a.usersCount !== undefined ? a.usersCount : 0; // ✅ changed to usersCount
                const usersB = b.usersCount !== undefined ? b.usersCount : 0; // ✅ changed to usersCount

                return newSortOrder === 'asc' ? usersA - usersB : usersB - usersA;
            })
        );
    
        setSortOrderUsers(newSortOrder);
    }; 

    // Sorting function for Onboarding (numerical sorting)
    const sortCompaniesByOnboarding = () => {
        const newSortOrder = sortOrderOnboarding === 'asc' ? 'desc' : 'asc';
    
        setFilteredCompanies((prevCompanies) => 
            [...prevCompanies].sort((a, b) => {
                const onboardingA = a.onboardingProgress ? parseFloat(String(a.onboardingProgress).replace('%', '')) : 0;
                const onboardingB = b.onboardingProgress ? parseFloat(String(b.onboardingProgress).replace('%', '')) : 0;
                return newSortOrder === 'asc' ? onboardingA - onboardingB : onboardingB - onboardingA;
            })
        );
    
        setSortOrderOnboarding(newSortOrder);
    };

    // Sorting function for Account Approval Status
    const sortCompaniesByAccountApprovalStatus = () => {
        const newSortOrder = sortOrderAccountApprovalStatus === 'asc' ? 'desc' : 'asc';
        
        const sortedCompanies = [...companies].sort((a, b) => {
            const accountApprovalStatusA = a.accountApprovalStatus ? a.accountApprovalStatus.toLowerCase() : '';
            const accountApprovalStatusB = b.accountApprovalStatus ? b.accountApprovalStatus.toLowerCase() : '';
            return newSortOrder === 'asc' ? accountApprovalStatusA.localeCompare(accountApprovalStatusB) : accountApprovalStatusB.localeCompare(accountApprovalStatusA);
        });

        setCompanies(sortedCompanies);
        setSortOrderAccountApprovalStatus(newSortOrder);
    };

    // Sorting function for activity status
    const sortCompaniesByStatus = () => {
        const newSortOrder = sortOrderStatus === 'asc' ? 'desc' : 'asc';
    
        setFilteredCompanies((prevCompanies) =>
            [...prevCompanies].sort((a, b) => {
                const statusA = a.activityStatus ? 1 : 0;
                const statusB = b.activityStatus ? 1 : 0;
                return newSortOrder === 'asc' ? statusA - statusB : statusB - statusA;
            })
        );
    
        setSortOrderStatus(newSortOrder);
    };

    const handleInviteChange = (e) => {
        const { name, value } = e.target;
        setInviteData((prev) => ({
            ...prev,
            [name]: value
        }));

        setInviteErrors((prev) => ({
            ...prev,
            [name]: '' // ✅ Clear error on change
        }));
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInviteCompany = async () => {
        const { companyName, vat, type, email, firstName, lastName, message } = inviteData;

        const newErrors = {};

        if (!companyName.trim()) newErrors.companyName = "Company name is required.";
        if (!vat.trim()) newErrors.vat = "VAT is required.";
        if (!email.trim()) newErrors.email = "Email is required.";
        if (!firstName.trim()) newErrors.firstName = "First name is required.";
        if (!lastName.trim()) newErrors.lastName = "Last name is required.";

        // ✅ Validate email format
        if (email.trim() && !isValidEmail(email.trim())) {
            newErrors.email = "Please enter a valid email address.";
        }

        if (Object.keys(newErrors).length > 0) {
            setInviteErrors(newErrors);
            return;
        }

        try {
            // Check if VAT exists
            const vatCheckResponse = await api.post(
                '/api/companies/check-vat',
                { vat }
            ); // ✅

            if (vatCheckResponse.data.exists) {
                setInviteErrors(prev => ({ ...prev, vat: "A company with this VAT number already exists." }));
                return;
            } else {
                setInviteErrors(prev => ({ ...prev, vat: '' }));
            }

            await api.post(
                '/api/companies/invite',
                { companyName, vat, type, email, firstName, lastName, message }
            ); // ✅

            setShowSuccessModal(true);
            setShowInviteModal(false);
            setInviteData({ companyName: '', vat: '', type: 'firm', email: '', firstName: '', lastName: '', message: inviteData.message });
            setInviteErrors({});
        } catch (error) {
            console.error("Error sending invite:", error);
            alert("Failed to send the invitation.");
        }
    };

    if (!user || !isAdminType(user.role)) {
        return <div>You are not authorized to view this page.</div>;
    }

    const totalPages = Math.ceil(filteredCompanies.length / companiesPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const noCompanies = filteredCompanies.length === 0;

    const getPaginationItems = () => {
        const siblingCount = 2;   // pages around current
        const boundaryCount = 1;  // always show first/last (1 each side)

        if (totalPages <= 1) return [1];

        const range = (start, end) => {
            const out = [];
            for (let i = start; i <= end; i++) out.push(i);
            return out;
        };

        const startPages = range(1, Math.min(boundaryCount, totalPages));
        const endPages = range(Math.max(totalPages - boundaryCount + 1, boundaryCount + 1), totalPages);

        const siblingsStart = Math.max(
            Math.min(currentPage - siblingCount, totalPages - boundaryCount - siblingCount * 2 - 1),
            boundaryCount + 2
        );

        const siblingsEnd = Math.min(
            Math.max(currentPage + siblingCount, boundaryCount + siblingCount * 2 + 2),
            totalPages - boundaryCount - 1
        );

        const items = [
            ...startPages,
            ...(siblingsStart > boundaryCount + 2 ? ["ellipsis"] : boundaryCount + 1 < totalPages - boundaryCount ? [boundaryCount + 1] : []),
            ...range(siblingsStart, siblingsEnd),
            ...(siblingsEnd < totalPages - boundaryCount - 1 ? ["ellipsis"] : totalPages - boundaryCount > boundaryCount ? [totalPages - boundaryCount] : []),
            ...endPages,
        ];

        // Remove any accidental duplicates (safety net)
        return items.filter((v, i) => items.indexOf(v) === i);
    };


    return (
        <>    
            <Sidebar ticketCount={tickets.length} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb />
                            {isMobile ? (
                                <h2>Mobile</h2>
                                ) : (
                                <h2 className="d-none">Desktop</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12}>
                                            <h1>Companies</h1>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <CompanyFilter
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                selectedCountry={selectedCountry}
                                                setSelectedCountry={setSelectedCountry}
                                                selectedCity={selectedCity}
                                                setSelectedCity={setSelectedCity}
                                                companies={companies}
                                            />
                                            {noCompanies ? (
                                                <Row>
                                                    <Col md={12}>
                                                        <Row className="mb-3">
                                                            <Col md={6} className="no-result offset-md-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                                <Image src={icNoCompanies} alt="No Companies" className="mb-4" />
                                                                <h2 className="mb-3">No Companies yet.</h2>
                                                                <p className="mb-4">Your Companies will be displayed here.</p>
                                                                <Button as={Link} to="/company-add" variant="primary">Add Company</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row>
                                                    <Col>
                                                        <div className="table-responsive list">
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className="th-fixed-company" onClick={sortCompaniesByName} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Company
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-company-country" onClick={sortCompaniesByCountry} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Country 
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-city" onClick={sortCompaniesByCity} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                City / Region
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-subscription" onClick={sortCompaniesBySubscription} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Subscription
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-users" onClick={sortCompaniesByUsers} style={{ cursor: 'pointer' }}>
                                                                            Users
                                                                            <span>
                                                                                <FaCaretUp />
                                                                                <FaCaretDown />
                                                                            </span>
                                                                        </th>
                                                                        {/* <th className="th-fixed-jobs" onClick={sortCompaniesByJob} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Jobs
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-onboarding" onClick={sortCompaniesByOnboarding} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Onboarding
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th> */}
                                                                        <th className="th-fixed-account"  onClick={sortCompaniesByAccountApprovalStatus} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Account
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-status"  onClick={sortCompaniesByStatus} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Status
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {currentCompanies.map((company) => (

                                                                        <tr
                                                                            className="company-row discovery-row"
                                                                            key={company._id}
                                                                            onClick={() => navigate(`/company-edit/${company._id}`)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {/* <Link
                                                                                to={`/company-edit/${company._id}`}
                                                                                style={{ textDecoration: 'none', color: 'inherit', flex: '1' }}
                                                                            > */}
                                                                                <td>
                                                                                    <div>
                                                                                        <img
                                                                                            src={company.logo ? company.logo : defaultLogo}
                                                                                            alt={company.title}
                                                                                            className="round"
                                                                                        />
                                                                                        <span className="text-ellipsis text-ellipsis-country-name">
                                                                                            <strong>{company.title}</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{company.country}</td>
                                                                                <td>
                                                                                    <div>{company.city}</div>
                                                                                    {company.cityRegion && company.cityRegion !== company.city && (
                                                                                        <div className="text-muted small">{company.cityRegion}</div>
                                                                                    )}
                                                                                </td>
                                                                                <td>{company.accessLevel}</td>
                                                                                <td onClick={(e) => e.stopPropagation()}>
                                                                                    <Link>
                                                                                        {company.usersCount !== undefined ? company.usersCount : 'n/a'}
                                                                                    </Link>
                                                                                </td>
                                                                                {/* <td>
                                                                                    <Link>
                                                                                        {company.openJobsTotal !== undefined && company.openJobsTotal !== null
                                                                                            ? company.openJobsTotal
                                                                                            : 'n/a'
                                                                                        }
                                                                                    </Link>
                                                                                </td>
                                                                                <td>    
                                                                                    <strong>
                                                                                        {`${company.onboardingProgress}%`}
                                                                                    </strong>
                                                                                </td> */}
                                                                                <td className={
                                                                                    company.accountApprovalStatus.toLowerCase() === "approved" ? "approved" :
                                                                                    company.accountApprovalStatus.toLowerCase() === "rejected" ? "rejected" :
                                                                                    company.accountApprovalStatus.toLowerCase() === "lifecycle review" ? "lifecycle-review" :
                                                                                    company.accountApprovalStatus.toLowerCase() === "under review" ? "under-review" : ""
                                                                                }>
                                                                                    <span className="d-flex align-items-center gap-2">
                                                                                        {company.accountApprovalStatus.toLowerCase() === "approved" && <img src={icApproved} alt="Approved" />}
                                                                                        {company.accountApprovalStatus.toLowerCase() === "rejected" && <img src={icRejected} alt="Rejected" />}
                                                                                        {company.accountApprovalStatus.toLowerCase() === "lifecycle review" && <img src={icRLifecycleReview} alt="Lifecycle Review" />}
                                                                                        {company.accountApprovalStatus.toLowerCase() === "under review" && <img src={icUnderReview} alt="Under Review" />}
                                                                                        {company.accountApprovalStatus}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <Tooltip id={`tooltip-status-${company._id}`}>
                                                                                                {company.activityStatus ? "Active" : "Inactive"}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <Badge bg={company.activityStatus ? 'active' : 'inactive'}>
                                                                                            &nbsp;
                                                                                        </Badge>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                            {/* </Link> */}
                                                                            <td onClick={(e) => e.stopPropagation()}>
                                                                                <Dropdown
                                                                                    drop="down"
                                                                                    align="end"
                                                                                    onToggle={(isOpen) => {
                                                                                        if (isOpen) {
                                                                                        requestAnimationFrame(() => window.dispatchEvent(new Event("resize"))); // ✅ force Popper update
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Dropdown.Toggle variant="link" className="text-dark p-0">
                                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu
                                                                                        renderOnMount
                                                                                        popperConfig={{ strategy: "fixed" }}
                                                                                        style={{ zIndex: 2000 }}
                                                                                    >
                                                                                        <Dropdown.Item as={Link} to={`/company-edit/${company._id}`} data-text="Edit">
                                                                                            <img src={icEdit} alt="Edit" />
                                                                                            Edit
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    if (!company._id) {
                                                                                                        console.error("Company ID is missing.");
                                                                                                        alert("Company ID is missing. Please try again.");
                                                                                                        return;
                                                                                                    }

                                                                                                    await api.put(
                                                                                                        `/api/companies/${company._id}/approval-status`,
                                                                                                        { accountApprovalStatus: "Under review" }
                                                                                                    );

                                                                                                    // Redirect after successful update
                                                                                                    window.location.href = `/company-review/${company._id}`;
                                                                                                } catch (error) {
                                                                                                    console.error("Error updating review status:", error.response?.data || error.message);
                                                                                                    alert("An error occurred while setting the company to 'Under review'.");
                                                                                                }
                                                                                            }}
                                                                                            data-text="Review"
                                                                                        >
                                                                                            <img src={icReview} alt="Review" />
                                                                                            Review
                                                                                        </Dropdown.Item>
                                                                                        {/* <Dropdown.Item as={Link} to={`/company-invite/${company._id}`} data-text="Invite to complete profile">
                                                                                            <img src={icUserEdit } alt="Invite to complete profile" />
                                                                                            Invite to complete profile
                                                                                        </Dropdown.Item> */}
                                                                                        {/* <Dropdown.Item as={Link} to={`/company-report/${company._id}`} data-text="Download report">
                                                                                            <img src={icDownload} alt="Download report" />
                                                                                            Download report
                                                                                        </Dropdown.Item> */}
                                                                                        <Dropdown.Item onClick={() => toggleActivityStatus(company._id, company.activityStatus)} data-text="Activate/Deactivate Account">
                                                                                            <img src={icRepeat} alt="Rejected" />
                                                                                            {company.activityStatus ? 'Deactivate Account' : 'Activate Account'}
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => handleDeleteCompany(company._id)} data-text="Delete">
                                                                                            <img src={icDelete} alt="Delete" />
                                                                                            Delete
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item 
                                                                                            href={company.url.startsWith('http://') || company.url.startsWith('https://') 
                                                                                                ? company.url 
                                                                                                : `https://${company.url}`}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            data-text="View Website"
                                                                                        >
                                                                                            View Website
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* Pagination Row with Total Count, Items Per Page Selector & "Go to Page" Input */}
                                            <Row className="pagination-wrapper">
                                                <Col className="d-flex align-items-center">
                                                    <span>
                                                        Total {filteredCompanies.length} {filteredCompanies.length === 1 ? 'company' : 'companies'}
                                                    </span>
                                                    <Pagination>
                                                        <Pagination.Prev 
                                                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                                                            disabled={currentPage === 1}
                                                        >
                                                            <BsChevronLeft />
                                                        </Pagination.Prev>
                                                        {getPaginationItems().map((item, index) =>
                                                            item === "ellipsis" ? (
                                                                <Pagination.Ellipsis key={`e-${index}`} disabled />
                                                            ) : (
                                                                <Pagination.Item
                                                                key={item}
                                                                active={item === currentPage}
                                                                onClick={() => handlePageChange(item)}
                                                                >
                                                                {item}
                                                                </Pagination.Item>
                                                            )
                                                       )}
                                                        <Pagination.Next 
                                                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <BsChevronRight />
                                                        </Pagination.Next>
                                                    </Pagination>
                                                </Col>
                                                <Col className="pagination-controls">
                                                    <div className="pagination-controls-per-page">
                                                        <Form.Select
                                                            value={companiesPerPage}
                                                            onChange={(e) => setCompaniesPerPage(Number(e.target.value))}
                                                        >
                                                            <option value="10">10 / page</option>
                                                            <option value="20">20 / page</option>
                                                            <option value="40">40 / page</option>
                                                        </Form.Select>
                                                    </div>
                                                    <label className="pagination-controls-goto-label" htmlFor="goto-page">
                                                        Go to
                                                    </label>
                                                    <Form.Control
                                                        className="pagination-controls-goto-input"
                                                        type="number"
                                                        value={currentPage}
                                                        onChange={(e) => {
                                                            const newPage = Number(e.target.value);
                                                            if (newPage >= 1 && newPage <= totalPages) {
                                                                setCurrentPage(newPage); // ✅ Only valid pages
                                                            }
                                                        }}
                                                        onBlur={() => {
                                                            if (currentPage < 1) setCurrentPage(1);
                                                            if (currentPage > totalPages) setCurrentPage(totalPages);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="buttons-row">
                        <Col>
                            <Button variant="outline-secondary" onClick={() => setShowImportModal(true)}>
                                Import companies from excel 
                            </Button>
                            <Button variant="outline-secondary" onClick={() => setShowInviteModal(true)}>
                                Invite a company
                            </Button>
                            <Link to="/company-add" className="btn btn-outline-primary">
                                Add new company
                            </Link>
                        </Col>
                    </Row>
                    
                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to delete this company?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-secondary" className="me-4" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                            <Button variant="danger" onClick={confirmDeleteCompany}>Delete</Button>
                        </Modal.Footer>
                    </Modal> 

                    <Modal className="with-form" show={showInviteModal} onHide={() => setShowInviteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Invite a new company</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        {/* Company Name */}
                                        <Form.Group controlId="companyName" className="validated mb-3">
                                            <Form.Label>Company Name <span>*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="companyName" 
                                                value={inviteData.companyName} 
                                                onChange={handleInviteChange} 
                                                isInvalid={!!inviteErrors.companyName}
                                                required
                                            />
                                            {inviteErrors.companyName && (
                                                <div className="custom-error-icon-wrapper">
                                                    <img
                                                        src={icValidationError}
                                                        alt={inviteErrors.companyName}
                                                        className="custom-error-icon"
                                                    />
                                                    <div className="custom-tooltip">
                                                        {inviteErrors.companyName}
                                                    </div>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        {/* VAT */}
                                        <Form.Group controlId="vat" className="validated mb-3">
                                            <Form.Label>VAT <span>*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="vat" 
                                                value={inviteData.vat} 
                                                onChange={handleInviteChange} 
                                                isInvalid={!!inviteErrors.vat} // ✅ Uses inviteErrors
                                                required
                                            />
                                            {inviteErrors.vat && (
                                                <div className="custom-error-icon-wrapper">
                                                    <img
                                                        src={icValidationError}
                                                        alt={inviteErrors.vat}
                                                        className="custom-error-icon"
                                                    />
                                                    <div className="custom-tooltip">
                                                        {inviteErrors.vat}
                                                    </div>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        {/* Type (Radio Inputs) */}
                                        <Form.Group className="validatedmb-3">
                                            <Form.Label>Type <span>*</span></Form.Label>
                                            <Row>
                                                <Col md={6}>
                                                    <label className="radio-option" htmlFor="Partner">
                                                        <div className="form-check">
                                                            <input
                                                                type="radio"
                                                                id="Partner"
                                                                name="type" // ✅ updated
                                                                value="partner" // ✅ updated
                                                                className="form-check-input"
                                                                checked={inviteData.type === 'partner'} 
                                                                onChange={handleInviteChange} // ✅ added for consistency
                                                                required
                                                            />
                                                            <span className="form-check-label">Partner</span>
                                                        </div>
                                                    </label>
                                                </Col>
                                                <Col md={6}>
                                                    <label className="radio-option" htmlFor="Firm">
                                                        <div className="form-check">
                                                            <input
                                                                type="radio"
                                                                id="Firm"
                                                                name="type" // ✅ updated
                                                                value="firm" // ✅ updated
                                                                className="form-check-input"
                                                                checked={inviteData.type === 'firm'} 
                                                                onChange={handleInviteChange}
                                                                required
                                                            />
                                                            <span className="form-check-label">Firm</span>
                                                        </div>
                                                    </label>
                                                </Col>

                                            </Row>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        {/* Email */}
                                        <Form.Group controlId="email" className="validated mb-3">
                                            <Form.Label>Email <span>*</span></Form.Label>
                                            <Form.Control 
                                                type="email" 
                                                name="email" 
                                                value={inviteData.email} 
                                                onChange={handleInviteChange} 
                                                isInvalid={!!inviteErrors.email}
                                                required
                                            />
                                            {inviteErrors.email && (
                                                <div className="custom-error-icon-wrapper">
                                                    <img
                                                        src={icValidationError}
                                                        alt={inviteErrors.email}
                                                        className="custom-error-icon"
                                                    />
                                                    <div className="custom-tooltip">
                                                        {inviteErrors.email}
                                                    </div>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        {/* First Name */}
                                        <Form.Group controlId="firstName" className="validated mb-3">
                                            <Form.Label>First Name Recipient <span>*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="firstName" 
                                                value={inviteData.firstName} 
                                                onChange={handleInviteChange} 
                                                isInvalid={!!inviteErrors.firstName} // ✅ Highlight if error
                                                required
                                            />
                                            {inviteErrors.firstName && (
                                                <div className="custom-error-icon-wrapper">
                                                    <img
                                                        src={icValidationError}
                                                        alt={inviteErrors.firstName}
                                                        className="custom-error-icon"
                                                    />
                                                    <div className="custom-tooltip">
                                                        {inviteErrors.firstName}
                                                    </div>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        {/* Last Name */}
                                        <Form.Group controlId="lastName" className="validated mb-3">
                                            <Form.Label>Last Name Recipient <span>*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="lastName" 
                                                value={inviteData.lastName} 
                                                onChange={handleInviteChange} 
                                                isInvalid={!!inviteErrors.lastName} // ✅ Highlight if error
                                                required
                                            />
                                            {inviteErrors.lastName && (
                                                <div className="custom-error-icon-wrapper">
                                                    <img
                                                        src={icValidationError}
                                                        alt={inviteErrors.lastName}
                                                        className="custom-error-icon"
                                                    />
                                                    <div className="custom-tooltip">
                                                        {inviteErrors.lastName}
                                                    </div>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        {/* Message (Predefined) */}
                                        <Form.Group controlId="message" className="mb-3">
                                            <Form.Label>Message</Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                name="message" 
                                                value={inviteData.message} 
                                                onChange={handleInviteChange} 
                                                rows={3}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-secondary" className="me-4" onClick={() => setShowInviteModal(false)}>Cancel</Button>
                            <Button variant="primary" onClick={handleInviteCompany}>Send</Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Success Modal */}
                    <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Image
                                src={icSucess}
                                alt=""
                                className="d-block m-auto mb-4"
                            />
                            <h2 className="text-center mb-3">Congratulations</h2>
                            <p className="text-center">
                                Congratulations! You have successfully invited a new company to join aBROADIFY.
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                            <Button variant="primary" onClick={() => setShowSuccessModal(false)}>Go to Companies</Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Import Companies Modal */}
                    <Modal className="with-form" show={showImportModal} onHide={() => setShowImportModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Import Companies</Modal.Title>
                        </Modal.Header>
                        
                        <Modal.Body>
                           <CompanyImport
                                onImportSuccess={() => {    
                                    fetchCompanies(); // Refresh the company list after successful import
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                            <Button variant="primary" onClick={() => setShowImportModal(false)}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </main>
        </>
    );
};

export default CompanyList;
